/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 17:22:52
 * @LastEditTime: 2020-09-22 16:03:16
 * @Description: 材料api
 */
import axios from '@/utils/axios'

export const getMaterials = (payload) => {
    return axios.get('/material', {
        params: payload
    })
}

export const updateMaterial = (id, data) => {
    return axios.put(`/material/${id}`, data)
}

export const createMaterial = (data) => {
    return axios.post(`/material`, data)
}

export const getMaterialById = (id) => {
    return axios.get(`/material/${id}`)
}

export const getRawMaterialWithPrice = (payload) => {
    return axios.get('/raw_material_latest_price', {
        params: payload
    })
}

export const getSemiMaterialWithCost = (payload) => {
    return axios.get('/semi_material_latest_cost', {
        params: payload
    })
}

export const createWater = (data) => {
    return axios.post('/waterMaterial', data)
}